import { useAppStore } from '@store'
import { Hole, Item, Walls } from '@types'
import getMorphsValidValue from '@utils/getMorphsValidValue'
import clsx from 'clsx'
import { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'

type Props = {
  morph: Item['morphs'][number]
  universal: boolean
  tabindex: number
}
export const MorphDictionary = {
  Alto: 'height',
  Fondo: 'thickness',
  Ancho: 'width',
} as Record<string, string>
export function HolePropertyInput({ morph, universal, tabindex }: Props) {
  const id = useAppStore((s) => s.currentObjectID)
  const t = useAppStore.use.t()
  const editHole = useAppStore.use.editHole()
  const editMorph = useAppStore.use.editMorph()
  const updateHole = useAppStore.use.updateHole()
  const [value, setValue] = useState(0)
  const hole = useAppStore.use.items().get(id) as Hole
  const wall = useAppStore.use.items().get(hole?.wall) as Walls
  useEffect(() => {
    setValue(morph.default)
  }, [morph.default])

  function handleKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      const value = parseInt(e.target.value)

      if (hole.type === 'holes') {
        const distI = hole.distI
        const wallWidth = wall.width
        const validMorph = getMorphsValidValue(morph, value)

        if (validMorph >= wallWidth) {
          setValue(wallWidth)
          editHole(id, { [MorphDictionary?.[morph.name]]: wallWidth, distI: 0, distD: 0 })
          editMorph(id, morph.name, wallWidth)
          updateHole(id)
        } else if (validMorph + distI >= wallWidth) {
          setValue(validMorph)
          editHole(id, {
            [MorphDictionary?.[morph.name]]: validMorph,
            distI: wallWidth - validMorph,
            distD: 0,
          })
          editMorph(id, morph.name, validMorph)
          updateHole(id)
        } else {
          setValue(validMorph)
          editHole(id, {
            [MorphDictionary?.[morph.name]]: validMorph,
            distD: wallWidth - distI - validMorph,
          })
          editMorph(id, morph.name, validMorph)
          updateHole(id)
        }

        return
      }
    }
  }
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setValue(parseInt(e.target.value))
  }
  return (
    <div className={clsx(' flex flex-col', morph.min === morph.max && 'mb-4')}>
      <label
        className='-mt-1 text-[11px] font-light text-C/Color3'
        htmlFor={morph.name}
      >
        {t(morph.name as `MSG_${number}`)}
      </label>
      <div className='flex flex-col'>
        <input
          type='number'
          min={morph.min}
          max={morph.max}
          name={morph.name}
          value={value}
          tabIndex={tabindex + 10}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          className={clsx(
            'pointer h-6 w-[60px] rounded border border-C/Color4 px-0.5 py-0 text-end text-C/Color4 focus:select-text focus:outline-blue-600',
            !universal && 'pointer-events-none border-gray-400 text-gray-400',
          )}
        />
      </div>

      {morph.min !== morph.max && (
        <div className='bottom-full left-1/2 transform text-[9px] font-light text-C/Color5'>
          {morph.min + ' x ' + morph.max}
        </div>
      )}
    </div>
  )
}
